import { KeyboardEvent } from 'react';
import { Controller } from 'react-hook-form';
import { Column, InputSelect, Label, MultiSelectGroup, Row, Text } from '~/commonComponents';
import { expectedDaysOptions, scheduleTypeOptions } from '~/components/PermanentJobsV2/utils';
import { EnforcePostAJobFunnelImprovements } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { Colors } from '~/themes/colors';
import { IBaseFormProps } from '../../Types';

export const ScheduleForm = ({ control, errors }: IBaseFormProps) => {
  const isEnforcePostAJobFunnelImprovement = useFeatureFlag(EnforcePostAJobFunnelImprovements);

  const allCodes = expectedDaysOptions.map((option) => option.code);

  return (
    <Column
      gap={24}
      columnGap={16}
      flexDirection={isEnforcePostAJobFunnelImprovement ? 'row' : 'column'}
    >
      <Column gap={8} {...(isEnforcePostAJobFunnelImprovement ? { minWidth: 226 } : {})}>
        <Label text="Schedule Type" required />
        <Controller
          control={control}
          name="scheduleType"
          render={({ field }) => (
            <InputSelect
              placeholder="Select Schedule Type"
              value={field.value}
              setValue={field.onChange}
              isSelectVisible={false}
              options={scheduleTypeOptions.map((option) => ({
                title: option.name,
                value: option.code,
              }))}
              error={!!errors?.scheduleType}
              dataCy="perm-schedule-type-select"
            />
          )}
        />
      </Column>

      <Column flex={1}>
        {isEnforcePostAJobFunnelImprovement ? (
          <Controller
            control={control}
            name="expectedDays"
            render={({ field }) => (
              <Column gap={8}>
                <Row justifyContent="space-between">
                  <Label text="Expected Days" required={false} />
                  <Text
                    bold
                    color={Colors.secondary_500}
                    cursor="pointer"
                    role="button"
                    tabIndex={0}
                    onClick={() => field.onChange(allCodes)}
                    onKeyDown={(e: KeyboardEvent) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        field.onChange(allCodes);
                      }
                    }}
                  >
                    Select All
                  </Text>
                </Row>
                <MultiSelectGroup
                  noWrapOptions
                  variant="pill"
                  value={field.value}
                  options={expectedDaysOptions.map((option) => ({
                    value: option.code,
                    label: option.name[0].toUpperCase(),
                  }))}
                  onChange={(selected) => field.onChange(selected.map((s) => s.value))}
                />
              </Column>
            )}
          />
        ) : (
          <>
            <Label text="Expected Days" required={false} />
            <Text color="neutral_500" italic>
              <Controller
                control={control}
                name="expectedDays"
                render={({ field }) => (
                  <MultiSelectGroup
                    isEnableSelectAll
                    value={field.value}
                    options={expectedDaysOptions.map((option) => ({
                      value: option.code,
                      label: option.name,
                    }))}
                    onChange={(selected) => field.onChange(selected.map((s) => s.value))}
                  />
                )}
              />
            </Text>
          </>
        )}
      </Column>
    </Column>
  );
};
